module.exports = __webpack_public_path__ + "static/media/paper-tart-1024x682.1626d8ea.jpg";